module.exports = __webpack_public_path__ + "static/media/msnstart_100.434f1a8f.ico";